export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello i18n in SFC!"])}
      }
    }
  })
}
